import { render, staticRenderFns } from "./SystemSidebar.vue?vue&type=template&id=b11bbc8c&"
import script from "./SystemSidebar.vue?vue&type=script&lang=js&"
export * from "./SystemSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SystemSidebar.vue?vue&type=style&index=0&id=b11bbc8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports